
import Vue, { CreateElement, RenderContext, VNode } from "vue";
import BaseIcon from "@/components/BaseIcon";

interface Props {
  reviewsStatsCount?: number;
}

export default Vue.extend({
  functional: true,
  name: "ContentFeedReviews",
  props: {
    reviewsStatsCount: { type: Number, default: 0 },
  },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const count = String(ctx.props.reviewsStatsCount);
    const icon = "sci-comment-cloud";
    return h(
      "div",
      {
        class: [
          ...(Array.isArray(ctx.data.class) ? ctx.data.class : [ctx.data.class]),
          ctx.data.staticClass,
          "feed-reviews-stats",
        ],
        on: ctx.listeners,
      },
      [
        h(BaseIcon, { attrs: { fontSize: 24 }, class: { "feed-reviews-stats__icon mr-1": true } }, [icon]),
        h("div", { class: { "feed-reviews-stats__count": true } }, [count]),
      ]
    );
  },
});
